import { useEffect, useRef, useState } from "react";
import { usePermission } from "../../../context/PermissionContext";
import { useAuth } from "../../../context/AuthProvider";
import { useContextApi } from "../../../context/ContextApi";
import Messages from "../../../constants/Messages";
import StateDropdown from "../../../constants/StateDropDown";
import { CircularProgress } from "@mui/material";
import AddGroup from "./AddGroup";
import EditGroup from "./EditGroup";
import PropTypes from "prop-types";
import { AddIcon, PhoneIcon, UserIcon, XIcon } from "../../../constants/Icons";

const AddSupplier = ({
  isOpen,
  onClose,
  onData,
  onAdd,
  isBtnLoading,
  groupId,
  selectedGroupDetails,
  onEditGroupData,
  groupName,
  onChangeGroup,
  onNewGroupsIn,
  newGroup,
  error: propError,
  setErrors: propSetErrors,
  resetAll = false,
  numberSuggest,
  addNewCustomNumber,
  isActive,
}) => {
  const { viewOption } = usePermission();
  const [isState, setSelectedState] = useState("");
  const { isUser } = useAuth();
  const { useEscapeKey } = useContextApi();
  const [isStatecode, setSelectedStateCode] = useState("");
  const [customerData, setCustomerData] = useState({
    ...(groupId !== null && groupId !== undefined && groupId !== ""
      ? { groupid: groupId }
      : {}),
    ...(selectedGroupDetails ? { selectedGroupDetails } : {}),
    name: onData?.name,
    number: onData?.number,
    email: "",
    addressline1: "",
    addressline2: "",
    state: isState,
    statecode: isStatecode,
    city: "",
    district: "",
    country: onData?.country || "INDIA",
    pincode: "",
    cinnumber: "",
    gstnumber: "",
    pannumber: "",
    referenceid: "",
    website: "",
    fssai: "",
    tradeName: "",
    nickname: "",
    contactPersonname: "",
    contactPersonNumber: "",
  });
  const hasFetched = useRef(false);
  const [internalError, internalSetErrors] = useState({});
  const error = propError !== undefined ? propError : internalError;
  const setErrors =
    propSetErrors !== undefined ? propSetErrors : internalSetErrors;

  const customerNameRef = useRef(null);
  const customerNumberRef = useRef(null);
  const customerEmailRef = useRef(null);
  const customerPincodeRef = useRef(null);
  const customerGSTRef = useRef(null);
  const customerPanRef = useRef(null);
  const customerCinRef = useRef(null);
  const customerRidRef = useRef(null);
  const addressLine1Ref = useRef(null);
  const addCustomerBtnRef = useRef(null);
  const address2Ref = useRef(null);
  const dropdownRef = useRef(null);
  const districtRef = useRef(null);
  const stateRef = useRef(null);
  const customerWebsiteRef = useRef(null);
  const customerTradeNameRef = useRef(null);
  const customerNickNameRef = useRef(null);
  const customerFssaiRef = useRef(null);
  const customerContactPersonNumberRef = useRef(null);
  const customerContactPersonNameRef = useRef(null);
  const suggestionRef = useRef([]);
  const serviceNameContainerRef = useRef(null);
  const [editGroupOpen, setEditGroupOpen] = useState(false);
  const [customerGroupOpen, setCustomerGroupOpen] = useState(false);
  const suggestionRefs = useRef([]);
  const [activeIndex, setActiveIndex] = useState(-1);
  const [selectedGroup, setSelectedGroup] = useState(selectedGroupDetails);
  const [addNewGroupOpen, setNewGroupOpen] = useState(false);
  const [groupNames, setGroupNames] = useState(groupName);
  const [highlightedIndex, setHighlightedIndex] = useState(-1);
  // const [showServicePopup, setShowServicePopup] = useState(false);
  // const [serviceNameSuggestions, setserviceNameSuggestions] = useState([]);
  // const [highlightedServiceIndex, setHighlightedServiceIndex] = useState(-1);

  useEffect(() => {
    if (onData) {
      setCustomerData((prev) => ({
        ...prev,
        name: onData?.name || "",
        number: onData?.number || "",
        country: onData?.country || "INDIA",
      }));
    }
  }, [onData]);

  useEffect(() => {
    if (!isOpen || !isActive) return;

    // Focus on customer name when modal opens
    const nameFocusTimer = setTimeout(() => {
      customerNameRef.current?.focus();
    }, 100);

    // Accordion handlers
    const billingAccordionEl = document.getElementById("flush-collapseOne");
    const gstAccordionEl = document.getElementById("flush-collapseTwo");
    const referenceIdAccordionEl = document.getElementById(
      "flush-collapseThree",
    );
    const contactPersonEl = document.getElementById("flush-collapsefive");

    const handleBillingAccordionShown = () => {
      setTimeout(() => {
        addressLine1Ref.current?.focus();
      }, 100);
    };

    const handleGSTAccordionShown = () => {
      setTimeout(() => {
        customerGSTRef.current?.focus();
      }, 100);
    };
    const handlecontactPersonAccordionShown = () => {
      setTimeout(() => {
        customerContactPersonNameRef.current?.focus();
      }, 100);
    };

    billingAccordionEl?.addEventListener(
      "shown.bs.collapse",
      handleBillingAccordionShown,
    );
    gstAccordionEl?.addEventListener(
      "shown.bs.collapse",
      handleGSTAccordionShown,
    );
    referenceIdAccordionEl?.addEventListener(
      "shown.bs.collapse",
      handleGSTAccordionShown,
    );
    contactPersonEl?.addEventListener(
      "shown.bs.collapse",
      handlecontactPersonAccordionShown,
    );

    // Cleanup
    return () => {
      clearTimeout(nameFocusTimer);
      billingAccordionEl?.removeEventListener(
        "shown.bs.collapse",
        handleBillingAccordionShown,
      );
      gstAccordionEl?.removeEventListener(
        "shown.bs.collapse",
        handleGSTAccordionShown,
      );
      referenceIdAccordionEl?.removeEventListener(
        "shown.bs.collapse",
        handleGSTAccordionShown,
      );
      contactPersonEl?.removeEventListener(
        "shown.bs.collapse",
        handlecontactPersonAccordionShown,
      );
    };
  }, [isOpen, isActive]);

  const validateForm = () => {
    const errors = {};

    if (!customerData?.name?.trim()) {
      errors.name = "Name is required";
    }

    if (customerData?.number) {
      if (!/^[0-9]+$/.test(customerData.number)) {
        errors.number = "Only numbers allowed";
      } else if (customerData.number.length > 20) {
        errors.number = "Maximum 20 digits allowed";
      }
    } else if (
      customerData.pincode &&
      !/^[0-9]{6}$/.test(customerData.pincode)
    ) {
      errors.pincode = Messages.ERROR.INVALID_PINCODE;
    } else if (customerData.email) {
      const trimmedEmail = customerData.email.trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmedEmail)) {
        errors.email = Messages.ERROR.INVALID_EMAIL;
      } else {
        customerData.email = trimmedEmail;
      }
    }
    if (customerData.website) {
      const trimmedWebsite = customerData.website.trim();

      const urlPattern = /^(https?:\/\/)([\w-]+\.)+[\w-]{2,}(\/\S*)?$/;

      if (!urlPattern.test(trimmedWebsite)) {
        errors.website =
          "Enter a valid website URL (must start with http:// or https://)";
      } else {
        customerData.website = trimmedWebsite;
      }
    }

    if (Object.keys(errors).length === 0) {
      if (
        customerData.gstnumber?.trim() !== "" &&
        isStatecode &&
        !/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[A-Z0-9]{3}$/.test(
          customerData.gstnumber,
        )
      ) {
        errors.gstnumber = Messages.ERROR.INVALID_GST_NUMBER;
      } else if (
        customerData.pannumber &&
        !/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(customerData.pannumber)
      ) {
        errors.pannumber = Messages.ERROR.INVALID_PAN_NUMBER;
      } else if (
        customerData.cinnumber &&
        !/^[A-Z]{1}[0-9]{5}[A-Z]{2}[0-9]{4}[A-Z]{3}[0-9]{6}$/.test(
          customerData.cinnumber,
        )
      ) {
        errors.cinnumber = Messages.ERROR.INVALID_CIN_NUMBER;
      } else if (customerData.fssai && !/^\d{14}$/.test(customerData.fssai)) {
        errors.fssai = Messages.ERROR.INVALID_FSSAI_NUMBER;
      }
    }
    setErrors(errors);
    if (Object.keys(errors).length > 0) {
      const firstErrorField = Object.keys(errors)[0];
      switch (firstErrorField) {
        case "name":
          customerNameRef.current?.focus();
          break;
        case "number":
          customerNumberRef.current?.focus();
          break;
        case "email":
          customerEmailRef.current?.focus();
          break;
        case "website":
          customerWebsiteRef.current?.focus();
          break;
        case "pincode":
          customerPincodeRef.current?.focus();
          break;
        case "gstnumber":
          customerGSTRef.current?.focus();
          break;
        case "pannumber":
          customerPanRef.current?.focus();
          break;
        case "cinnumber":
          customerCinRef.current?.focus();
          break;
        case "fssai":
          customerFssaiRef.current?.focus();
          break;
        default:
          break;
      }
    }
    return Object.keys(errors).length === 0;
  };

  const handleEditGroupClose = () => {
    setEditGroupOpen(false);
  };

  const handleEditWalletOpen = () => {
    setEditGroupOpen(true);
  };

  const handleGrouAdd = (groupName) => {
    onNewGroupsIn(groupName);
    // const newGroup = { _id: Date.now().toString(), name: groupName };
    // setGroupNames((prev) => [newGroup,...prev, ]);
    handleNewGroupClose();
  };
  const handleSetNewGroup = () => {
    setGroupNames((prev) => [newGroup, ...prev]);
  };
  const handleOnEditIn = (groupName, id) => {
    onEditGroupData(groupName, id); // send updated group name
    handleEditGroupClose();
  };

  const resetForm = () => {
    setCustomerData({
      groupid: "",
      name: "",
      number: "",
      email: "",
      addressline1: "",
      addressline2: "",
      state: "",
      statecode: "",
      city: "",
      district: "",
      country: "India",
      pincode: "",
      cinnumber: "",
      gstnumber: "",
      pannumber: "",
      referenceid: "",
      website: "",
      fssai: "",
      tradeName: "",
      nickname: "",
      contactPersonname: "",
      contactPersonNumber: "",
    });
    setSelectedStateCode("");
    setSelectedState("");
    setErrors("");
  };

  const handleChange = (e) => {
    setErrors("");
    const { name, value } = e.target;
    let updatedValue = value;

    if (name === "number") {
      updatedValue = updatedValue.replace(/\D/g, ""); // only digits

      if (updatedValue.length > 20) {
        updatedValue = updatedValue.slice(0, 20);
      }
    }
    if (["gstnumber", "pannumber", "cinnumber"].includes(name)) {
      updatedValue = updatedValue.replace(/\s/g, "");
    }
    setCustomerData((prev) => ({
      ...prev,
      [name]: updatedValue,
      // ...(groupId ? { groupid: groupId } : {}),
    }));
  };

  const handleStateChange = (e) => {
    const { value } = e.target;
    const label = e.target.options[e.target.selectedIndex].text;
    setSelectedStateCode(value);
    setSelectedState(label);
    setCustomerData((prev) => ({ ...prev, state: label, statecode: value }));
  };

  const handleClose = () => {
    resetForm();
    onClose();
  };
  useEscapeKey(handleClose);
  const handleAdd = async (e, data) => {
    e.preventDefault();
    if (!validateForm()) return;

    const baseData = data || customerData;
    const dataToAdd = { ...baseData };

    // remove nickname if empty
    if (!dataToAdd.nickname || !dataToAdd.nickname.trim()) {
      delete dataToAdd.nickname;
    }

    // ✅ remove number if empty
    if (!dataToAdd.number || !dataToAdd.number.toString().trim()) {
      delete dataToAdd.number;
    }

    if (groupId) {
      dataToAdd.groupid = groupId;
    }

    const result = await onAdd(dataToAdd, resetForm);
  };
  const stopEventPropagation = (e) => e.stopPropagation();
  const handleEnterKey = (e, fieldName, nextRef = null, isLast = false) => {
    if (e.key === "Enter") {
      e.preventDefault();

      // if (fieldName === "phone" && !(customerData.phone || "").trim()) {
      //   setErrors((prev) => ({
      //     ...prev,
      //     phone: Messages.ERROR.EMPTY_PHONE,
      //   }));
      //   return;
      // }

      if (customerData.gstnumber?.trim() !== "" && !isStatecode) {
        setErrors((prev) => ({
          ...prev,
          state: "State is required when GST Number is entered",
        }));
      }

      if (isLast) {
        handleAdd(e);
      } else {
        nextRef?.current?.focus();
      }
    }
  };

  const handleNewGroupOpen = () => {
    setNewGroupOpen(true);
    setCustomerGroupOpen(false);
  };

  const handleNewGroupClose = () => {
    setNewGroupOpen(false);
  };

  const handleSelectAll = () => {
    setSelectedGroup({ name: "All Customer" });
    setCustomerData((prev) => {
      const { groupid, ...rest } = prev; // remove groupid
      return rest;
    });
    setCustomerGroupOpen(false);
    if (onChangeGroup) onChangeGroup({ name: "All Customer" });
  };

  const handleSelectMy = () => {
    // console.log("my");
    setSelectedGroup({ name: "My Customer" });
    setCustomerData((prev) => {
      const { groupid, ...rest } = prev; // remove groupid
      return rest;
    });
    setCustomerGroupOpen(false);
    if (onChangeGroup) onChangeGroup({ name: "My Customer" });
  };

  const handleSelectGroup = (customer) => {
    setSelectedGroup(customer);
    if (customer?._id) {
      setCustomerData((prev) => ({ ...prev, groupid: customer._id }));
    }
    setCustomerGroupOpen(false);

    if (onChangeGroup) onChangeGroup(customer);
  };

  const handleKeyDown = (e) => {
    if (!customerGroupOpen) return;

    if (e.key === "ArrowDown") {
      e.preventDefault();
      setActiveIndex((prev) => (prev < groupNames.length + 1 ? prev + 1 : 0));
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setActiveIndex((prev) => (prev > 0 ? prev - 1 : groupNames.length + 1));
    } else if (e.key === "Enter") {
      e.preventDefault();
      if (activeIndex === 0) {
        isUser.stype === "MAIN" ? handleSelectAll() : handleSelectMy();
      } else if (activeIndex > 0 && groupNames[activeIndex - 1]) {
        handleSelectGroup(groupNames[activeIndex - 1]);
      } else if (
        activeIndex === groupNames.length + 1 &&
        isUser.stype === "MAIN"
      ) {
        handleNewGroupOpen();
      }
    }
  };

  const handleOutsideClick = (e) => {
    if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
      setCustomerGroupOpen(false);
    }
  };

  const handlePaymodeKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();

      // just submit whatever current data is (even if number is empty)
      handleAdd(e, customerData);
    }
  };
  // useEffect(() => {
  //   if (highlightedIndex >= 0 && suggestionRef.current[highlightedIndex]) {
  //     suggestionRef.current[highlightedIndex].scrollIntoView({
  //       block: "nearest",
  //       behavior: "smooth",
  //     });
  //   }
  //   if (
  //     highlightedServiceIndex >= 0 &&
  //     suggestionRef.current[highlightedServiceIndex]
  //   ) {
  //     suggestionRef.current[highlightedServiceIndex].scrollIntoView({
  //       block: "nearest",
  //       behavior: "smooth",
  //     });
  //   }
  // }, [highlightedIndex, highlightedServiceIndex]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        serviceNameContainerRef.current &&
        !serviceNameContainerRef.current.contains(e.target)
      ) {
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    if (customerGroupOpen) {
      document.addEventListener("mousedown", handleOutsideClick);
    }
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [customerGroupOpen]);

  useEffect(() => {
    if (activeIndex >= 0 && suggestionRefs.current[activeIndex]) {
      suggestionRefs.current[activeIndex].scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    }
  }, [activeIndex]);

  useEffect(() => {
    if (selectedGroupDetails && selectedGroupDetails._id) {
      // valid group → set
      setSelectedGroup(selectedGroupDetails);
      setCustomerData((prev) => ({
        ...prev,
        groupid: selectedGroupDetails._id,
      }));
    } else {
      // "All" or no group → remove groupid
      setSelectedGroup({
        name: isUser.stype === "MAIN" ? "All Customer" : "My Customer",
      });
      setCustomerData((prev) => {
        const { groupid, ...rest } = prev;
        return rest;
      });
    }
  }, [selectedGroupDetails]);

  useEffect(() => {
    if (groupName) {
      setGroupNames(groupName);
    }
  }, [groupName]);

  useEffect(() => {
    if (newGroup) {
      handleSelectGroup(newGroup);
    }
  }, [newGroup]);

  useEffect(() => {
    if (hasFetched.current) return;
    hasFetched.current = true;
    if (newGroup) {
      handleSetNewGroup();
    }
  }, [newGroup]);

  useEffect(() => {
    if (resetAll && isOpen) {
      isUser.stype === "MAIN" ? handleSelectAll() : handleSelectMy();
    }
  }, [resetAll, isOpen]);

  if (!isOpen) return null;

  return (
    <div>
      <div className="modal-backdrop show"></div>
      <div
        className="modal show"
        id="CustomerModal"
        tabIndex="-1"
        aria-modal="true"
        role="dialog"
        style={{ display: "block" }}
      >
        <div
          className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable"
          // onClick={stopEventPropagation}
        >
          <div className="modal-content">
            <div className="modal-header">
              <h6 className="modal-title me-2">Add Supplier</h6>
              {/* <div
                className="position-relative"
                ref={dropdownRef}
                tabIndex={0}
                onKeyDown={handleKeyDown}
                style={{ outline: "none" }}
              >
                <li
                  className="cursor-pointer wallet-list list-group-item p-1 d-flex align-items-center border bg-label-info"
                  style={{
                    borderRadius: "10px",
                    width: "160px",
                    whiteSpace: "nowrap",
                  }}
                  onClick={() => {
                    setCustomerGroupOpen(true);
                    setActiveIndex(0);
                  }}
                >
                  <div
                    className="d-flex align-items-center justify-content-between"
                    style={{ width: "150px" }}
                  >
                    <div className="d-flex align-items-center mx-2 flex-grow-1 overflow-hidden">
                      <i className="ng ng-ng-customers-icon me-2 fs-6"></i>
                      <span className="mb-0 text-primary text-truncate">
                        {selectedGroup?.name}
                      </span>
                    </div>

                    <i className="bx bx-chevron-down ms-2 font-18"></i>
                  </div>
                </li>

                {customerGroupOpen && groupNames && (
                  <ul className="suggestions-list">
                    {isUser.stype === "MAIN" ? (
                      <li
                        ref={(el) => (suggestionRefs.current[0] = el)}
                        onClick={handleSelectAll}
                        className={`suggestion-item ${
                          activeIndex === 0 ? "active-suggestion" : ""
                        }`}
                      >
                        <i className="ng ng-ng-customers-icon me-2 fs-6"></i>All
                        Supplier
                      </li>
                    ) : (
                      <li
                        ref={(el) => (suggestionRefs.current[0] = el)}
                        onClick={handleSelectMy}
                        className={`suggestion-item ${
                          activeIndex === 0 ? "active-suggestion" : ""
                        }`}
                      >
                        <i className="ng ng-ng-customers-icon me-2 fs-6"></i>My
                        Supplier
                      </li>
                    )}
                    {groupNames?.map((customer, index) => (
                      <li
                        key={customer?._id}
                        ref={(el) => (suggestionRefs.current[index + 1] = el)}
                        onClick={() => handleSelectGroup(customer)}
                        className={`suggestion-item ${
                          activeIndex === index + 1 ? "active-suggestion" : ""
                        }`}
                      >
                        <i className="ng ng-ng-customers-icon me-2 fs-6"></i>
                        {customer?.name}
                      </li>
                    ))}
                    {isUser.stype === "MAIN" && (
                      <li
                        ref={(el) =>
                          (suggestionRefs.current[groupNames?.length + 1] = el)
                        }
                        onClick={handleNewGroupOpen}
                        className={`suggestion-item bg-label-infos ${
                          activeIndex === groupNames?.length + 1
                            ? "active-suggestion"
                            : ""
                        }`}
                      >
                        <span className="d-flex align-items-center">
                          <i className="ng ng-ng-add-icon me-2 fs-6"></i>New
                          Group
                        </span>
                      </li>
                    )}
                  </ul>
                )}
              </div> */}
              <button
                type="button"
                className="btn-close"
                onClick={handleClose}
                data-bs-dismiss="modal"
                aria-label="Close"
                fdprocessedid="jgxcje"
              ></button>
            </div>
            <div className="modal-body bg-light">
              <div className="card">
                <div className="card-body">
                  <div className="row g-3">
                    <div className="col-lg-6">
                      <label htmlFor="name" className="form-label">
                        Name <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="name"
                        autoComplete="off"
                        value={customerData.name}
                        onChange={handleChange}
                        onKeyDown={(e) =>
                          handleEnterKey(e, "name", customerNumberRef)
                        }
                        ref={customerNameRef}
                      />
                      {error.name && (
                        <div className="error-message invalid-feedback">
                          {error.name}
                        </div>
                      )}
                    </div>
                    <div className="col-lg-6">
                      <label htmlFor="number" className="form-label">
                        Number
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        autoComplete="off"
                        maxLength={20}
                        name="number"
                        ref={customerNumberRef}
                        value={customerData.number}
                        onChange={handleChange}
                        onKeyDown={handlePaymodeKeyDown}
                        // onKeyDown={(e) =>
                        //   handleEnterKey(e, "number", customerNameRef)
                        // }
                      />
                      {error.number && (
                        <div className="error-message invalid-feedback">
                          {error.number}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="accordion accordion-flush">
                <div className="accordion-item">
                  <h2 className="accordion-header" id="flush-headingOne">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseOne"
                      aria-expanded="false"
                      aria-controls="flush-collapseOne"
                      fdprocessedid="5b1j1a"
                    >
                      Billing Details (Optional)
                    </button>
                  </h2>
                  <div
                    id="flush-collapseOne"
                    className="accordion-collapse collapse"
                    aria-labelledby="flush-headingOne"
                    data-bs-parent="#accordionFlushExample"
                  >
                    <div className="accordion-body">
                      <div className="row g-3">
                        <div className="col-lg-6">
                          <label htmlFor="bsValidation1" className="form-label">
                            Address Line 1
                          </label>
                          <textarea
                            type="text"
                            className="form-control"
                            autoComplete="off"
                            onChange={handleChange}
                            name="addressline1"
                            value={customerData.addressline1}
                            ref={addressLine1Ref}
                            onKeyDown={(e) =>
                              handleEnterKey(e, "addressline1", address2Ref)
                            }
                          ></textarea>
                        </div>

                        <div className="col-lg-6">
                          <label htmlFor="bsValidation1" className="form-label">
                            Address Line 2
                          </label>
                          <textarea
                            type="text"
                            className="form-control"
                            autoComplete="off"
                            onChange={handleChange}
                            name="addressline2"
                            ref={address2Ref}
                            value={customerData.addressline2}
                            onKeyDown={(e) =>
                              handleEnterKey(e, "addressline2", districtRef)
                            }
                          ></textarea>
                        </div>

                        <div className="col-lg-6">
                          <label htmlFor="bsValidation1" className="form-label">
                            District
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            autoComplete="off"
                            onChange={handleChange}
                            ref={districtRef}
                            name="district"
                            value={customerData.district}
                            onKeyDown={(e) =>
                              handleEnterKey(e, "district", stateRef)
                            }
                          />
                        </div>

                        <div className="col-lg-6">
                          <label htmlFor="bsValidation1" className="form-label">
                            State
                          </label>
                          <StateDropdown
                            stateChange={handleStateChange}
                            value={isStatecode}
                            ref={stateRef}
                            onKeyDown={(e) =>
                              handleEnterKey(e, "state", customerPincodeRef)
                            }
                          />
                        </div>

                        <div className="col-lg-3">
                          <label htmlFor="bsValidation1" className="form-label">
                            Country
                          </label>
                          <input
                            type="text"
                            disabled
                            className="form-control"
                            autoComplete="off"
                            onChange={handleChange}
                            name="country"
                            value={customerData.country}
                          />
                        </div>

                        <div className="col-lg-3">
                          <label htmlFor="bsValidation1" className="form-label">
                            Pincode
                          </label>
                          <input
                            type="text"
                            maxLength={6}
                            className="form-control"
                            autoComplete="off"
                            onChange={handleChange}
                            name="pincode"
                            ref={customerPincodeRef}
                            value={customerData.pincode}
                            onKeyDown={(e) =>
                              handleEnterKey(e, "pincode", customerEmailRef)
                            }
                          />
                          {error.pincode && (
                            <div className="error-message invalid-feedback">
                              {error.pincode}
                            </div>
                          )}
                        </div>

                        <div className="col-lg-6">
                          <label htmlFor="bsValidation1" className="form-label">
                            Email
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            autoComplete="off"
                            onChange={handleChange}
                            value={customerData.email}
                            ref={customerEmailRef}
                            name="email"
                            onKeyDown={(e) =>
                              handleEnterKey(e, "email", customerGSTRef)
                            }
                          />

                          {error.email && (
                            <div className="error-message invalid-feedback">
                              {error.email}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="accordion-item">
                  <h2 className="accordion-header" id="flush-headingTwo">
                    <button
                      className="accordion-button collapsed "
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseTwo"
                      aria-expanded="false"
                      aria-controls="flush-collapseOne"
                      fdprocessedid="ysxib"
                    >
                      Business Details (Optional)
                    </button>
                  </h2>
                  <div
                    id="flush-collapseTwo"
                    className="accordion-collapse collapse"
                    aria-labelledby="flush-headingTwo"
                    data-bs-parent="#accordionFlushExample"
                  >
                    <div className="accordion-body">
                      <div className="row g-3">
                        <div className="col-lg-4">
                          <label htmlFor="bsValidation1" className="form-label">
                            GST Number
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            autoComplete="off"
                            onChange={(e) => {
                              e.target.value = e.target.value.toUpperCase();
                              handleChange(e);
                            }}
                            value={customerData.gstnumber}
                            maxLength={15}
                            ref={customerGSTRef}
                            name="gstnumber"
                            onKeyDown={(e) =>
                              handleEnterKey(e, "gstnumber", customerPanRef)
                            }
                          />
                          {error.gstnumber && (
                            <div className="error-message invalid-feedback">
                              {error.gstnumber}
                            </div>
                          )}
                          {customerData.gstnumber?.trim() !== "" &&
                            !isStatecode && (
                              <div className="error-message invalid-feedback">
                                State is required when GST Number is entered
                              </div>
                            )}
                        </div>

                        <div className="col-lg-4">
                          <label htmlFor="bsValidation1" className="form-label">
                            PAN Number
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            autoComplete="off"
                            onChange={handleChange}
                            maxLength={10}
                            name="pannumber"
                            ref={customerPanRef}
                            value={customerData.pannumber}
                            onKeyDown={(e) =>
                              handleEnterKey(e, "pannumber", customerCinRef)
                            }
                          />
                          {error.pannumber && (
                            <div className="error-message invalid-feedback">
                              {error.pannumber}
                            </div>
                          )}
                        </div>

                        <div className="col-lg-4">
                          <label htmlFor="bsValidation1" className="form-label">
                            CIN Number
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            autoComplete="off"
                            onChange={handleChange}
                            maxLength={21}
                            value={customerData.cinnumber}
                            ref={customerCinRef}
                            name="cinnumber"
                            onKeyDown={(e) =>
                              handleEnterKey(
                                e,
                                "cinnumber",
                                customerContactPersonNameRef,
                              )
                            }
                          />
                          {error.cinnumber && (
                            <div className="error-message invalid-feedback">
                              {error.cinnumber}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="accordion-item">
                  <h2 className="accordion-header" id="flush-headingfive">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapsefive"
                      aria-expanded="false"
                      aria-controls="flush-collapsefive"
                      fdprocessedid="9b1j1b"
                    >
                      Contact Person Details
                    </button>
                  </h2>
                  <div
                    id="flush-collapsefive"
                    className="accordion-collapse collapse"
                    aria-labelledby="flush-headingfive"
                    data-bs-parent="#accordionFlushExample"
                  >
                    <div className="accordion-body">
                      <div className="row g-3">
                        <div className="col-lg-6">
                          <label htmlFor="bsValidation1" className="form-label">
                            Contact Person Name
                          </label>
                          <div className="input-group">
                            <span className="input-group-text">
                              <UserIcon/>{" "}
                            </span>
                            <input
                              type="text"
                              className="form-control"
                              autoComplete="off"
                              onChange={handleChange}
                              value={customerData.contactPersonname}
                              ref={customerContactPersonNameRef}
                              name="contactPersonname"
                              onKeyDown={(e) =>
                                handleEnterKey(
                                  e,
                                  "contactPersonname",
                                  customerContactPersonNumberRef,
                                )
                              }
                            />
                          </div>
                          {/* {error.contactPersonName && (
                            <div className="error-message invalid-feedback">
                              {error.contactPersonName}
                            </div>
                          )} */}
                        </div>
                        <div className="col-lg-6">
                          <label htmlFor="bsValidation1" className="form-label">
                            Contact Person Number
                          </label>
                          <div className="input-group">
                            <span className="input-group-text">
                              <PhoneIcon/>{" "}
                            </span>
                            <input
                              type="text"
                              className="form-control"
                              autoComplete="off"
                              maxLength={10}
                              onChange={handleChange}
                              value={customerData.contactPersonNumber}
                              ref={customerContactPersonNumberRef}
                              name="contactPersonNumber"
                              onKeyDown={(e) =>
                                handleEnterKey(
                                  e,
                                  "contactPersonNumber",
                                  customerRidRef,
                                )
                              }
                            />
                          </div>
                          {/* {error.contactPersonNumber && (
                            <div className="error-message invalid-feedback">
                              {error.contactPersonNumber}
                            </div>
                          )} */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* { viewOption("customerSettings", "isReferenceId") && ( */}
                <div className="accordion-item">
                  <h2 className="accordion-header" id="flush-headingThree">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseThree"
                      aria-expanded="false"
                      aria-controls="flush-collapseThree"
                      fdprocessedid="6b1j1b"
                    >
                      Other Details (Optional)
                    </button>
                  </h2>
                  <div
                    id="flush-collapseThree"
                    className="accordion-collapse collapse"
                    aria-labelledby="flush-headingThree"
                    data-bs-parent="#accordionFlushExample"
                  >
                    <div className="accordion-body">
                      <div className="row g-3">
                        <div className="col-lg-4">
                          <label htmlFor="bsValidation1" className="form-label">
                            Reference No
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            autoComplete="off"
                            onChange={handleChange}
                            value={customerData.referenceid}
                            ref={customerRidRef}
                            name="referenceid"
                            onKeyDown={(e) =>
                              handleEnterKey(
                                e,
                                "referenceid",
                                customerWebsiteRef,
                              )
                            }
                          />

                          {error.referenceid && (
                            <div className="error-message invalid-feedback">
                              {error.referenceid}
                            </div>
                          )}
                        </div>
                        <div className="col-lg-4">
                          <label htmlFor="bsValidation1" className="form-label">
                            Website
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            autoComplete="off"
                            onChange={handleChange}
                            value={customerData.website}
                            ref={customerWebsiteRef}
                            name="website"
                            onKeyDown={(e) =>
                              handleEnterKey(e, "website", customerTradeNameRef)
                            }
                          />

                          {error.website && (
                            <div className="error-message invalid-feedback">
                              {error.website}
                            </div>
                          )}
                        </div>
                        <div className="col-lg-4">
                          <label htmlFor="bsValidation1" className="form-label">
                            Trade Name
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            autoComplete="off"
                            onChange={handleChange}
                            value={customerData.tradeName}
                            ref={customerTradeNameRef}
                            name="tradeName"
                            onKeyDown={(e) =>
                              handleEnterKey(
                                e,
                                "tradeName",
                                customerNickNameRef,
                              )
                            }
                          />

                          {/* {error.tradeName && (
                            <div className="error-message invalid-feedback">
                              {error.tradeName}
                            </div>
                          )} */}
                        </div>
                        <div className="col-lg-4">
                          <label htmlFor="bsValidation1" className="form-label">
                            Nick Name
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            autoComplete="off"
                            onChange={handleChange}
                            value={customerData.nickname}
                            ref={customerNickNameRef}
                            name="nickname"
                            onKeyDown={(e) =>
                              handleEnterKey(e, "nickname", null, true)
                            }
                          />

                          {/* {error.nickname && (
                            <div className="error-message invalid-feedback">
                              {error.nickname}
                            </div>
                          )} */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* )} */}
              </div>
            </div>
            <div className="modal-footer d-block">
              <button
                type="button"
                className="btn btn-outline-secondary text-left"
                onClick={handleClose}
              >
                <XIcon/> Cancel
              </button>
              {isBtnLoading ? (
                <button className="btn btn-jobcard pb-0 text-right" disabled>
                  <CircularProgress size={22} className="text-white" />
                </button>
              ) : (
                <button
                  type="button"
                  className="btn btn-jobcard text-right"
                  ref={addCustomerBtnRef}
                  onClick={handleAdd}
                >
                  <AddIcon/> Add Supplier
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
      {addNewGroupOpen && (
        <AddGroup
          onClose={handleNewGroupClose}
          onNewGroupIn={handleGrouAdd}
          // isBtnLoading={addGroupload}
        />
      )}
      {editGroupOpen && (
        <EditGroup
          onClose={handleEditGroupClose}
          onNewGroupIn={handleOnEditIn}
          // isBtnLoading={addGroupload}
          onData={selectedGroupDetails}
        />
      )}
    </div>
  );
};

AddSupplier.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onAdd: PropTypes.func.isRequired,
};

export default AddSupplier;
